<template>
    <div v-loading="loading">
        <div class="card card-custom card-stretch gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="flaticon2-delivery-package text-primary"></i>
                    </span>
                    <h3 class="card-label"><b class="title-header">{{ BusinessTitle }}</b></h3>
                </div>
            </div>
            <div class="card-body ">
                <div class="row mb-4">
                    <div class="ml-4">
                        <el-button type="primary" @click="createForm()">{{label}}</el-button>
                    </div>
                </div>
                <el-form :model="dynamicValidateForm" ref="ruleForm" class="demo-dynamic">
                        <table id="uniquetable" class="table rounded table-top" style="width: 100%;">
                            <thead class="thead-dark text-center">
                                <tr>
                                    <th style="width: 45%;">証憑名</th>
                                    <th style="width: 45%;">備考</th>
                                    <th style="width: 10%;"></th>
                                </tr>
                            </thead>
                            <tbody v-if="(dynamicValidateForm.dataForm.length > 0)" >
                                <tr v-for="(data, index) in dynamicValidateForm.dataForm" :key="index">
                                    <td style="width: 45.5%;">
                                        <el-form-item :key="data.key" :prop="`dataForm.${index}.file_name`"
                                            style="margin-bottom:0">
                                            <el-input v-model="data.file_name" :maxlength="maxLengthHimokuName"
                                                :key="index">
                                            </el-input>
                                        </el-form-item>
                                    </td>
                                    <td style="width: 45.5%;">
                                        <el-form-item :key="data.key" :prop="`dataForm.${index}.file_biko`"
                                            style="margin-bottom:0">
                                            <el-input v-model="data.file_biko" :maxlength="maxLengthHimokuBiko"
                                                :key="index">
                                            </el-input>
                                        </el-form-item>
                                    </td>
                                    <td class="text-center" style="width: 10%;">
                                        <el-button class="delete-btn" type="danger" icon="el-icon-delete" circle
                                            @click="openPopup(data.file_id, index)"></el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    <el-form-item>
                        <div class="mt-8">
                            <el-button type="primary" @click="addLine()">行追加</el-button>
                        </div>
                        <div class="text-center mb-12">
                            <el-button type="primary" @click="submitForm()">確定</el-button>
                        </div>
                    </el-form-item>
                    <input type="hidden" name="_csrf" v-model="dynamicValidateForm._csrf" />
                </el-form>
            </div>
        </div>
        <Popup :id="popupId" :content="popupMessage">
            <b-button class="btn-primary" @click="deleteVoucher()">
                はい
            </b-button>
            <b-button class="btn-primary" @click="$bvModal.hide(popupId)">
                いいえ
            </b-button>
        </Popup>
    </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import { GET_LIST_VOUCHER } from "@/core/services/store/voucher.module";
import { mapActions, mapGetters } from "vuex";
import { SET_TITLE_BUSINESS } from "@/core/services/store/business.module";
import Popup from '@/view/components/Popup'
import { SUCCESS_MESSAGE, DELETE_MESSAGE } from "@/core/config/constant";
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
    components: {
        Popup
    },
    data() {
        return {
            popupId: 'costPopup',
            popupMessage: DELETE_MESSAGE,
            loading: false,
            dynamicValidateForm: {
                dataForm: [],
                _csrf:''
            },
            isSubmit: false,
            maxLengthHimokuName: 32,
            maxLengthHimokuBiko: 64,
            selectedDeleteId: '',
            selectedDeleteIndex: '',
            label: ''
        };
    },
    computed: {
        ...mapGetters(["getListCost", "getSuccessful", "BusinessTitle", 'ListVoucher', 'form6Url']),
    },
    async created() {
        this.loading = true
        if (this.BusinessTitle == null) {
            await this.setTitleBusiness()
        }
        await this.GetAllUrlAdmin()
        if (this.form6Url) {
            this.label = 'その他証憑フォーム更新'
        } else {
            this.label = 'その他証憑フォーム作成'
        }
        await this.GetListVoucher()
        this.dynamicValidateForm.dataForm = this.ListVoucher
        this.dynamicValidateForm._csrf = getCsrfRandom()
        this.loading = false
    },
    methods: {
        ...mapActions([GET_LIST_VOUCHER, SET_TITLE_BUSINESS, "GetAllUrlAdmin"]),
        async addLine() {
            await this.dynamicValidateForm.dataForm.push({
                "file_id": "",
                "file_name": "",
                "file_biko": ""
            });
            const table = document.getElementById('uniquetable')
            const lastRow = table.rows[table.rows.length - 1]
            lastRow.scrollIntoView({ block: "start", behavior: "smooth" })
        },

        async submitForm() {
            this.isSubmit = true
            this.$refs["ruleForm"].clearValidate()
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.loading = true
                    apiService.post(`voucher/add-voucher`, { dataForm: this.dynamicValidateForm.dataForm }).then(async (data) => {
                        if (data && data.data && data.data.success) {
                            this.notifySuccess(SUCCESS_MESSAGE)
                            await this.GetListVoucher()
                            this.dynamicValidateForm.dataForm = this.ListVoucher
                        } else {
                            if (data.data.code == 422) {
                                this.showErrorMessage(data.data.data, 'ruleForm')
                            } else if (data.data.code == 400) {
                                this.notifyError(data.data.message)
                            } else {
                                this.notifyError('error server')
                            }
                        }

                        this.loading = false
                    }).catch(e => {
                        this.loading = false
                        this.notifyError(e)
                    })
                } else {
                    return false;
                }
            });
            this.isSubmit = false
        },
        openPopup(id, index) {
            this.selectedDeleteId = id
            this.selectedDeleteIndex = index
            this.$bvModal.show(this.popupId)
        },
        async deleteVoucher() {
            this.$bvModal.hide(this.popupId)
            if (!this.selectedDeleteId) {
                this.dynamicValidateForm.dataForm.splice(this.selectedDeleteIndex, 1)
            } else {
                try {
                    if (this.dynamicValidateForm.dataForm.length == 1) {
                        this.notifyError('証憑名を１つ以上登録してください。')
                        return;
                    }
                    this.loading = true
                    const response = await apiService.get(`voucher/delete-voucher/${this.selectedDeleteId}`)
                    if (response.data.code == 200) {
                        this.notifySuccess(SUCCESS_MESSAGE)
                    }
                    if (response.data.code == 400) {
                        this.notifyError(response.data.message)
                    }
                    await this.GetListVoucher()
                    this.dynamicValidateForm.dataForm = this.ListVoucher
                    this.loading = false
                } catch (e) {
                    this.loading = false
                    this.notifyError(e)
                }
            }
        },
        async createForm() {
            await apiService.get(`voucher/create-form`).then(async (data) => {
                if (data && data.data && data.data.success) {
                    this.notifySuccess(SUCCESS_MESSAGE)
                    this.label = 'その他証憑フォーム更新'
                } else {
                    if (data.data.code == 400) {
                        this.notifyError(data.data.message)
                    } else {
                        this.notifyError('error server')
                    }
                }
                await this.GetListVoucher()
                this.dynamicValidateForm.dataForm = this.ListVoucher
                this.loading = false
            }).catch(e => {
                this.loading = false
                this.notifyError(e)
            })
        }
    }

}
</script>

<style scoped>
.table-top,
.table-top th,
.table-top td {
    border: 1px solid #EBEDF3;
    border-collapse: collapse;
}

.avoidClicks {
    pointer-events: none;
}

#uniquetable thead {
    display: block;
    width: 100%;
}

#uniquetable tbody {
    display: block;
    width: 100%;
    padding-bottom: 20px;
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 790px;
    }

    #uniquetable tbody tr,
    #uniquetable thead tr {
        width: 100%;
        display: table;
    }

    #uniquetable tbody tr {
    min-height: 75px;
}
.show_err_data_null {
    height: 100%;
    width: 1529px;
}
</style>
